import axios from 'axios'
import { openCart } from './cart-modal.js'

const updateButtonUI = (button, state) => {
    switch (state) {
    case 'loading':
        button.style.width = `${button.getBoundingClientRect().width}px`
        button.style.height = `${button.getBoundingClientRect().height}px`
        button.setAttribute('disabled', 'disabled')
        button.dataset.state = 'loading'
        break
    default:
        button.removeAttribute('style')
        button.removeAttribute('disabled')
        button.dataset.state = 'idle'
    }
}

const handleAddToCart = async (event) => {
    event.preventDefault()

    const button = event.target.closest('.addToCart')
    const productForm = document.querySelector('#productForm')
    const formData = new FormData(productForm)
    formData.set('attributes[recent_id]', formData.get('id'))

    updateButtonUI(button, 'loading')

    try {
        await axios.post('/cart/add.js', formData)
    } catch (e) {
        console.error('Error adding product to cart')
        return
    }

    await getAndShowCartModal()
    updateButtonUI(button, 'idle')
}

const getAndShowCartModal = async () => {
    try {
        const cartSectionResponse = await axios.get('?sections=cart-modal,cart-indicator')
        document.querySelector('[data-cart-modal-inner]').innerHTML = cartSectionResponse.data['cart-modal']
        document.querySelector('[data-cart-indicator]').innerHTML = cartSectionResponse.data['cart-indicator']
        openCart()
    } catch (e) {
        console.error('Error getting cart section html')
    }
}

document.querySelectorAll('[data-add-to-cart]').forEach((button) => {
    button.addEventListener('click', handleAddToCart)
})
